export default __webpack_public_path__ + "static/media/imgSelect.62bf01b8.svg";